<template>
  <img
    v-if="src || getFilePath"
    :src="src || getFilePath"
    class="img-max select-none"
    importance="high"
    alt="image"
    style="user-drag: none;"
    rel="preload"
    >
  <div
    v-else-if="hasPlaceholder"
    :class="placeholderClass"
    />
</template>

<script>
import commonProps from '@/mixins/commonProps';

export default {
  mixins: [commonProps],
  computed: {
    getFilePath() {
      if (this.filePath) {
        const images = require.context('@/assets/', true, /\.png|.jpg$/);
        return images(`./${this.filePath}`);
      }
      return false;
    },
  },
};
</script>
